/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react';
import sequenceStoreData from 'Stores/sequenceData';
import { observer } from 'mobx-react';
import { ReactComponent as TickIcon } from 'Assets/salesgear/svg/tick.svg';
import { NoSequenceComponent } from './NoSequence';

const SequenceList = observer(props => {
  const { setSelectedSeq, setLoading, loading, setEnableConfirmButton } = props;
  const [sequenceData, setSequenceData] = useState('');

  const addSelectedFalg = id => {
    sequenceData.map(seqObj => {
      if (id === seqObj.id) seqObj.isSelected = true;
      else seqObj.isSelected = false;
    });
    setSequenceData(sequenceData);
  };

  const addSelectedFlagForFirstSequence = sequence => {
    if (sequence && sequence[0] && sequence[0].id) {
      sequence[0].isSelected = true;
      return sequence;
    }
  };

  const setSelectedSequence = sequence => {
    setSelectedSeq(sequence.id);
  };

  const getFirstSequence = seqList => {
    if (seqList && seqList[0] && seqList[0].id) return seqList[0];
  };

  const constructSequenceData = data => {
    if (data && data.length) {
      const firstSequence = getFirstSequence(data);
      setSequenceData(addSelectedFlagForFirstSequence(data));
      setSelectedSequence(firstSequence);
      setLoading(false);
      setEnableConfirmButton(true);
    } else {
      setSequenceData([]);
      setEnableConfirmButton(false);
      setLoading(false);
    }
  };

  const hasSequences = () => {
    if (sequenceData && sequenceData.length > 0) return true;
    return false;
  };

  const selectedSeqAction = (e, seqId) => {
    e.preventDefault();
    addSelectedFalg(seqId);
    setSelectedSeq(seqId);
  };

  const getOwnerInitial = owner => {
    if (owner) {
      const fn = owner.firstName;
      const ln = owner.lastName;
      if (fn && ln) return fn[0] + ln[0];
      if (fn) return fn.slice(0, 2);
      if (ln) return ln.slice(0, 2);
    }
  };

  useEffect(() => {
    if (sequenceStoreData.sequenceData)
      constructSequenceData(sequenceStoreData.sequenceData);
  }, [sequenceStoreData.sequenceData]);

  return !loading ? (
    <div className="sequenceCont">
      {hasSequences() ? (
        // eslint-disable-next-line consistent-return
        sequenceData.map((seqObj, index) => {
          const { id, name, isSelected, owner } = seqObj;
          if (name)
            return (
              <div
                className={`sequenceDetails name ${
                  isSelected ? 'selected' : ''
                }`}
                key={index}
                data-name={name}
                data-id={id}
                onClick={e => selectedSeqAction(e, id)}
              >
                <span className="name">{name}</span>
                <span className="owner">{getOwnerInitial(owner)} </span>
                {isSelected && (
                  <span className="tickIcon">
                    <TickIcon />
                  </span>
                )}
              </div>
            );
        })
      ) : (
        <div className="noSequence">
          <NoSequenceComponent />
        </div>
      )}
    </div>
  ) : (
    <div className="sequenceLoading">
      <LoadingComponent />
    </div>
  );
});

const LoadingComponent = () => {
  return Array.from({ length: 10 }, (value, index) => (
    <div className="sequenceDetails" key={`sequenceDetails ${index}`}>
      <span className="linear-background" />
    </div>
  ));
};

export default SequenceList;
export { SequenceList };
